import React, { useState } from "react";
import { DeleteButton, useConfirmationStore } from "components";
import { useDeveloperStore } from "../stores/developerStore";
import CopyButton from "./CopyButton";

// Форматує дату для таблиці токенів
const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleString("uk-UA");
};

// Панель керування API-токенами: створення, список, відкликання
const TokensPanel = () => {
  const { tokens, newToken, isCreating, createToken, clearNewToken, revokeToken } =
    useDeveloperStore();
  const { showConfirmation } = useConfirmationStore();
  const [name, setName] = useState("");

  // Створення токена з форми
  const handleCreate = async (event) => {
    event.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;

    const ok = await createToken(trimmed);
    if (ok) setName("");
  };

  // Відкликання з підтвердженням: після цього інтеграція перестане працювати
  const handleRevoke = (token) => {
    showConfirmation({
      title: "Відкликати токен?",
      message: `Токен «${token.name}» (${token.token_prefix}…) перестане працювати негайно. Усі інтеграції, що його використовують, отримають 401.`,
      onConfirm: () => revokeToken(token.id),
    });
  };

  return (
    <div className="developer-panel">
      <div className="developer-panel-header">
        <div>
          <h4>API-токени</h4>
          <p className="muted">
            Токен не має терміну дії та дозволяє лише читання (GET). Передавайте його в
            заголовку <code>Authorization: Bearer &lt;токен&gt;</code>.
          </p>
        </div>
        <form className="token-create-form" onSubmit={handleCreate}>
          <input
            type="text"
            placeholder="Назва токена, напр. «Агент додавання позицій»"
            value={name}
            maxLength={100}
            onChange={(event) => setName(event.target.value)}
            disabled={isCreating}
          />
          <button type="submit" className="primary-button" disabled={isCreating || !name.trim()}>
            {isCreating ? "Створення…" : "Створити токен"}
          </button>
        </form>
      </div>

      {newToken && (
        <div className="new-token-banner">
          <div className="new-token-banner-text">
            <strong>Токен «{newToken.name}» створено.</strong> Скопіюйте його зараз: після
            закриття цього повідомлення він більше не показується.
          </div>
          <div className="new-token-banner-value">
            <code>{newToken.token}</code>
            <CopyButton text={newToken.token} label="Скопіювати токен" />
            <button type="button" className="ghost-button" onClick={clearNewToken}>
              Закрити
            </button>
          </div>
        </div>
      )}

      {tokens.length === 0 ? (
        <p className="muted empty-state">Активних токенів немає.</p>
      ) : (
        <table id="tokens-table">
          <thead>
            <tr>
              <th>Назва</th>
              <th>Токен</th>
              <th>Створено</th>
              <th>Останнє використання</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tokens.map((token) => (
              <tr key={token.id}>
                <td>{token.name}</td>
                <td>
                  <code>{token.token_prefix}…</code>
                </td>
                <td>{formatDate(token.created_at)}</td>
                <td>{formatDate(token.last_used_at)}</td>
                <td>
                  <DeleteButton onDelete={() => handleRevoke(token)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TokensPanel;
